<template>
	<div class="header-container">
		<!-- 头部背景图 -->
		<div class="header-bg row-center">
			<img src="../../assets/home/top_bg.png" alt="" />
		</div>
		<div class="header-content row-center wrap">
			<div class="header-inner">
				<!-- 顶部标题 -->
				<div class="flex-sb col-center" v-if="user &&userinfo && JSON.stringify(userinfo) !== '{}'">
					<div class="header-title flex-center">
						<!-- <div class="logo flex-center" v-if="type.logo">
							<img :src="type.logo" alt="" />
						</div> -->
						<div class="title">
							{{$language.systemTitle.name}}
						</div>
						<div class="title-col">{{$language.systemTitle.name}}</div>
					</div>
					<div class="user-con col-center">
						<div class="avatar">
							<img src="../../assets/profile_picture.png" alt="" />
						</div>
						<el-dropdown placement="bottom" style="width: 0;flex-grow: 1;" @command="handleCommand">
							<div class="el-dropdown-link flex-sb" style="cursor: pointer;">
								<div class="nickname">欢迎您，{{userinfo.name}}</div>
								<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="a">退出登录</el-dropdown-item>
								<!-- <el-dropdown-item>狮子头</el-dropdown-item>
						    <el-dropdown-item>螺蛳粉</el-dropdown-item>
						    <el-dropdown-item disabled>双皮奶</el-dropdown-item>
						    <el-dropdown-item divided>蚵仔煎</el-dropdown-item> -->
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
				<div class="header-title flex-center" v-else>
					<div class="logo flex-center" v-if="$language.systemIco.name">
						<img :src="$language.systemIco.name" alt="" />
					</div>
					<div class="title">
						{{$language.systemTitle.name}}
					</div>
					<div class="title-col">{{$language.systemTitle.name}}</div>
				</div>
				<slot></slot>
			</div>
			<div class="page-bottom row-center wrap">
				<div class="flex-sb">
					<div>{{$language.floorText.children.first.name}}</div>
					<div style="width: 20px;height:1px" v-if="$language.floorText.children.second.name"></div>
					<div>{{$language.floorText.children.second.name}}</div>
					<!-- <div>联系邮箱：18686739927@126.com</div> -->
				</div>
				<div style="width: 100%;text-align: center;padding-top: 20px;">
					{{$language.floorText.children.third.name}}
				</div>
			</div>
		</div>
		<div class="process-hover">
			{{$language.login.children.loginFlowChart.name}}
			<div class="process-img" @click="openWindow($language.login.children.loginFlowChartImg.name)">
				<img :src="$language.login.children.loginFlowChartImg.name" alt="" />
			</div>
		</div>
		<div class="process-hover-Second">
			{{$language.login.children.technicalSupportText.name}}
			<div class="process-img" @click="openWindow($language.login.children.technicalSupportImg.name)">
				<img :src="$language.login.children.technicalSupportImg.name" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		type
	} from '../../common/config.js'
	export default {
		name: 'cus-header',
		props: {
			user: {
				type: Boolean,
				default: false
			}
		},
		components: {},
		data() {
			return {
				type,
				userinfo: {}
			}
		},
		created() {
			let userinfo = localStorage.getItem("userinfo")
			if (userinfo) {
				this.userinfo = JSON.parse(userinfo)
			}
		},
		mounted() {

		},
		methods: {
			// 下拉菜单点击
			handleCommand(command) {
				if (command === 'a') {
					this.logout()
				}
			},
			//退出登录
			logout() {
				localStorage.setItem("userinfo", '')
				localStorage.setItem("access_token", '')
				localStorage.setItem("refresh_token", '')
				this.$router.push("/")
			},
			openWindow(url) {
				window.open(url)
			}
		}

	}
</script>

<style lang="scss" scoped>
	.header-container {
		position: relative;

		.header-bg {
			position: absolute;
			width: 100%;
			top: 0;
			z-index: 0;

			img {
				min-width: 1000px;
				width: 100%;
			}
		}

		.header-content {
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;

			.header-inner {
				width: 100%;
				max-width: 1320px;

				.user-con {
					width: 248px;
					height: 50px;
					background: rgba(246, 246, 246, .2);
					border-radius: 25px;

					// opacity: 0.2;
					.avatar {
						background-color: white;
						width: 40px;
						border-radius: 25px;
						height: 40px;
						margin: 5px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.el-dropdown-link {
						color: white;
						width: 100%;
						font-size: 16px;
						padding: 0 15px;
						box-sizing: border-box;

						.nickname {
							flex-grow: 1;
							width: 0;
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
						}

						i {
							flex-shrink: 0;
							padding-right: 0 20px;
							color: #B4D3FA;
						}
					}
				}

				.header-title {
					padding: 3.125rem 0;

					.title-col {
						display: none;
					}

					.logo {
						width: 4rem;
						height: 4rem;
						flex-shrink: 0;
					}

					.title {
						font-size: 48px;
						color: #FFFFFF;
						text-shadow: 0px 2px 10px rgba(131, 157, 190, 0.35);
						font-weight: bold;
						margin-left: 1rem;
						box-sizing: border-box;
					}

					img {
						width: 100%;
					}
				}
			}

			.page-bottom {
				width: 100%;
				color: #949BB0;
				padding: 5rem;
			}
		}

		.floor {
			// padding: 5.625rem 0;
			// text-align: center;
			// color: #949BB0;
		}
	}

	.process-hover,
	.process-hover-Second {
		bottom: 250px;
		position: fixed;
		right: 30px;
		bottom: 50px;
		width: 20px;
		text-align: center;
		color: white;
		background: #358BF6;
		padding: 14px 10px;
		border-radius: 4px;
		cursor: pointer;
		box-sizing: content-box;

		.process-img {
			position: absolute;
			width: 460px;
			padding: 10px;
			bottom: 0;
			right: 100%;
			border: 1px solid #358BF6;
			display: none;
			transition: all .5s;
			background-color: white;
			box-shadow: 0px 0px 16px 0px rgba(102, 102, 102, 0.3);
			border-radius: 2px;

			img {
				width: 100%;
			}
		}
	}

	.process-hover-Second {
		bottom: 280px;

		.process-img {
			width: 300px;
		}
	}

	.process-hover:hover .process-img,
	.process-hover-Second:hover .process-img {
		display: block;
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 922px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {
		.header-container {
			.header-bg {
				width: 100%;
				overflow: hidden;
			}

			.header-content {
				.header-inner {
					.header-title {
						justify-content: center;
						padding: 1.875rem 0;
						padding-left: 1rem;

						.title {
							width: 45rem;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 767px) {


		.header-container {
			.header-bg {
				width: 100%;
				overflow: hidden;
			}

			// overflow: hidden;
			.header-content {
				.header-inner {
					max-width: 100%;

					.header-title {
						padding: 1.25rem;

						.logo {
							width: 3rem;
							height: 3rem;
							flex-shrink: 0;
						}

						.title {
							display: none;
						}

						.title-col {
							color: white;
							padding-left: 1.25rem;
							font-size: 1.25rem;
							display: block;
							font-weight: bold;
						}
					}
				}

				.page-bottom {
					padding: 1.875rem;
				}
			}
		}


	}
</style>